export default __webpack_public_path__ + "static/media/pharrell7.c124ba35.webp";